import axios from '../utils/axios';
import Constants from './types';
import { getSessionId, getPayloadFromError } from '../utils';
import { loadRecordByIdSearch } from './search';
import store from 'src/store';
import history from 'src/utils/history';

export const loadRecordLinks = entityVersionId => {
  const sessionId = getSessionId();

  return dispatch => {
    dispatch(loadRecordLinksRequest());
    axios({
      method: 'get',
      url: '/openempi-ws-rest/1.0/record-links',
      headers: {
        Accept: 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      params: {
        entityId: entityVersionId,
        state: 'P',
        maxResults: 1000,
        includeCustom: true
      }
    })
      .then(res => {
        dispatch(loadRecordLinksSuccess(transformLinks(res.data)));
      })
      .catch(err => {
        dispatch(loadRecordLinksFailure(err));
      });
  };
};

export const addRecordLink = recordLink => {
  const sessionId = getSessionId();
  return dispatch => {
    axios({
      method: 'POST',
      url: '/openempi-ws-rest/1.0/record-links',
      headers: {
        Accept: 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      params: {
        entityId: recordLink.entityId
      },
      data: recordLink
    })
      .then(res => {
        dispatch(addRecordLinkSuccess(res.data));
      })
      .catch(err => {
        dispatch(addRecordLinkFailure(err));
      });
  };
};

export const classifyLinkAsMatch = (
  entityVersionId,
  recordLink,
  nextUrlOnSuccess,
  recordId
) => {
  const sessionId = getSessionId();
  return dispatch => {
    axios({
      method: 'PUT',
      url: '/openempi-ws-rest/1.0/record-links/' + recordLink.recordLinkId,
      headers: {
        Accept: 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      params: {
        entityId: entityVersionId
      },
      data: recordLink
    })
      .then(res => {
        dispatch(classifyAsMatchSuccess(transformLink(res.data)));
        if (recordId) {
          dispatch(loadRecordByIdSearch(entityVersionId, recordId));
        } else {
          history.push(nextUrlOnSuccess);
        }
      })
      .catch(err => {
        dispatch(classifyAsMatchFailure(err));
      });
  };
};

export const classifyLinkAsNonMatch = (
  entityVersionId,
  recordLinkId,
  nextUrlOnSuccess,
  recordId
) => {
  const sessionId = getSessionId();
  return dispatch => {
    axios({
      method: 'DELETE',
      url: '/openempi-ws-rest/1.0/record-links/' + recordLinkId,
      headers: {
        Accept: 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      params: {
        entityId: entityVersionId
      }
    })
      .then(res => {
        dispatch(classifyAsNonMatchSuccess(transformLink(res.data)));
        if (recordId) {
          dispatch(loadRecordByIdSearch(entityVersionId, recordId));
        } else {
          history.push(nextUrlOnSuccess);
        }
      })
      .catch(err => {
        dispatch(classifyAsNonMatchFailure(err));
      });
  };
};

let mapOfUsersById = null;
const getMapOfUsersById = () => {
  if (mapOfUsersById) {
    return mapOfUsersById;
  }
  const { users } = store.getState().users;
  const mapUserById = {};
  users.forEach(user => (mapUserById[user.id] = user));
  mapOfUsersById = mapUserById;
  return mapOfUsersById;
};

const transformLinks = links => {
  const newLinks = links.map(link => transformLink(link));
  return newLinks;
};

const transformLink = link => {
  const mapUserById = getMapOfUsersById();
  link.recordLinkId = link.recordLinkId.substring(1);
  if (link.userCreatedBy && mapUserById[link.userCreatedBy]) {
    link.userCreatedBy = mapUserById[link.userCreatedBy].username;
  }
  if (link.weight) {
    link.weight = parseFloat(link.weight.toPrecision(6));
  } else {
    link.weight = 0;
  }
  link.source =
    link.source === 'Probabilistic'
      ? 'Probabilistic Matching Algorithm'
      : link.source;
  return link;
};

export const clearRecordLinksError = () => {
  return {
    type: Constants.RECORD_LINKS_CLEAR_ERROR
  };
};

const loadRecordLinksRequest = () => {
  return {
    type: Constants.RECORD_LINKS_GET_REQUEST
  };
};

const loadRecordLinksSuccess = data => {
  return {
    type: Constants.RECORD_LINKS_GET_SUCCESS,
    payload: data
  };
};

const loadRecordLinksFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.RECORD_LINKS_GET_FAILURE,
    payload
  };
};

const classifyAsMatchSuccess = data => {
  return {
    type: Constants.RECORD_LINKS_CLASSIFYMATCH_SUCCESS,
    payload: data
  };
};

const classifyAsMatchFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.RECORD_LINKS_CLASSIFYMATCH_FAILURE,
    payload
  };
};

const classifyAsNonMatchSuccess = data => {
  return {
    type: Constants.RECORD_LINKS_CLASSIFYNMATCH_SUCCESS,
    payload: data
  };
};

const classifyAsNonMatchFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.RECORD_LINKS_CLASSIFYNMATCH_FAILURE,
    payload
  };
};

const addRecordLinkSuccess = data => {
  return {
    type: Constants.RECORD_LINKS_ADDRECORDLINK_SUCCESS,
    payload: data
  };
};

const addRecordLinkFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.RECORD_LINKS_ADDRECORDLINK_FAILURE,
    payload
  };
};
